import { render } from "./SaveTemplate.vue?vue&type=template&id=a0a07fc2&scoped=true&ts=true"
import script from "./SaveTemplate.vue?vue&type=script&lang=tsx"
export * from "./SaveTemplate.vue?vue&type=script&lang=tsx"

import "./SaveTemplate.vue?vue&type=style&index=0&id=a0a07fc2&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0a07fc2"]])

export default __exports__